import { createAction } from "@reduxjs/toolkit";

import type { ActionTypeEnum, ResourceTypeEnum } from "@superblocksteam/shared";

import { defineAction } from "core/store/utils/action";

import slice from "./slice";

/**
 * We need to clear dirty state outside of persistApi's start reducer. This is necessary
 * because the start reducer is called whenever updateApi.success.type is fired, however
 * persistApi itself is throttled. Therefore, we should remove dirty state only when
 * we fire the persistApi and not when we end up throttling it.
 */
export const clearV2DirtyState = defineAction<{ id: string }>(
  slice.name,
  "clearV2DirtyState",
);

export const clearResponseV2Api = defineAction<{ id: string }>(
  slice.name,
  "clearResponseV2Api",
);

export const fetchApiPermissions = createAction(
  "fetchApiPermissions/start",
  (
    apiId: string,
    type: ResourceTypeEnum.WORKFLOWS | ResourceTypeEnum.SCHEDULED_JOBS,
  ) => ({ payload: { apiId, type } }),
);

export const fetchApiPermissionsSuccess = createAction(
  "fetchApiPermissions/success",
  (payload: { apiId: string; permissions: Array<ActionTypeEnum> }) => ({
    payload,
  }),
);

export const fetchApiPermissionsError = createAction(
  "fetchApiPermissions/error",
  (error: string) => ({ payload: { error } }),
);
